import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import {LogserviceService} from '../logservice/logservice.service';
import {AgentScript} from '../../model/AgentScript';
const httpOptions = {
    headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Access-Control-Allow-Origin': '*',
        'Cache-Control': 'private, max-age=1200'
    })
};

@Injectable({
    providedIn: 'root'
})
export class SectionBuilderService {
    
    constructor(private httpClient:HttpClient ,private logService:LogserviceService) { }

    httpHeaders = new HttpHeaders();
    backendUrl = environment.apiURL;

    getAllSections():Observable<any> {
        this.logService.logMessage('Section Groups','debug');
        return this.httpClient.get(this.backendUrl+'getAllSectionGroup', httpOptions).pipe(retry(2), catchError(this.handleError));
    }

    getSectionDetail(id :number) {
        return this.httpClient.get(this.backendUrl + 'cache/getSection/' + id, {
            headers: this.httpHeaders
        }).pipe(retry(2), catchError(this.handleError));
    }
    getSectionGroupDetail(id :number) {
        return this.httpClient.get(this.backendUrl + 'getSectionGroup/' + id, {
            headers: this.httpHeaders
        }).pipe(retry(2), catchError(this.handleError));
    }
    onSaveSectionGroup(payload:any):Observable<any> {
        return this.httpClient.post(this.backendUrl+'saveSectionGroup', payload, httpOptions);
    }
    onSaveSection(payload:any):Observable<any> {
        return this.httpClient.post(this.backendUrl+'saveSection', payload, httpOptions);
    }

    onDeleteSectionGroup(payload:any):Observable<any> {
        console.log(payload);
        return this.httpClient.post(this.backendUrl+'deleteSectionGroup', payload, httpOptions);
    }

    onDeleteSection(payload:any):Observable<any> {
        console.log(payload);
        return this.httpClient.post(this.backendUrl+'deleteSection', payload, httpOptions);
    }
    getMenus(name:string){
        var payload = {"entityName": name};
        return this.httpClient.post(this.backendUrl+ 'gquery',payload, httpOptions);
    }
    
    private handleError(errorObj: HttpErrorResponse | any) {
        const _self = this;
        let errorMessage: string;
        let body: any;
        if (errorObj instanceof HttpErrorResponse) {
            if (errorObj.ok === false && errorObj.status === 0) {
                errorMessage = 'No internet connection or server might be unreachable. Please try again after sometime.';
            } else {
                body = errorObj.error || '';
                errorMessage = body.message ? body.message : body.error.message;
            }
        }
        return throwError(errorMessage);
    }
}
